import type { CSSProperties } from 'react';
import { memo } from 'react';
import type { RenditionSet, RenditionUrl } from '@hst-horizon/horizon-ui';
import { ImageWithRenditions } from '@hst-horizon/horizon-ui';

type BrandImageRendition = '58px' | '116px' | '232px' | '464px';
const smallResolution = '116px';
const mediumResolution = '232px';
const bigResolution = '464px';

type Sizes = '150px' | '100px' | '80px' | '50px';

const brandRenditionSets: RenditionSet[] = [
    { rendition: '58px', set: [smallResolution, smallResolution] },
    { rendition: '116px', set: [smallResolution, mediumResolution] },
    { rendition: '232px', set: [mediumResolution, bigResolution] },
    { rendition: '464px', set: [bigResolution, bigResolution] },
];

interface BaseBrandImageProps {
    url?: string;
    alt: string | undefined;
    mixBlendMode?: CSSProperties['mixBlendMode'];
}

type FixedBrandImageProps = {
    renditionSize?: never;
    size: Sizes;
    aspectRatio?: number;
} & BaseBrandImageProps;

type StretchBrandImageProps = {
    renditionSize: BrandImageRendition;
    size?: never;
} & BaseBrandImageProps;

type BrandImageProps = FixedBrandImageProps | StretchBrandImageProps;

const transformBrandUrl = (url: string) => {
    if (!url) {
        return undefined;
    }
    const paths = url.split('.');
    return `${paths.slice(0, -1).join('.')}-*.${
        paths[paths.length - 1]
    }` as RenditionUrl;
};

const BrandImage = ({
    url = '',
    alt = 'brandImage',
    ...props
}: BrandImageProps) => {
    const renditionUrl = transformBrandUrl(url);
    return (
        <ImageWithRenditions
            renditionUrl={renditionUrl}
            renditionSet={brandRenditionSets}
            alt={alt}
            {...props}
        />
    );
};

export default memo(BrandImage);
